




















import { Component, Vue, Prop } from "vue-property-decorator";
import axios, { resHandle } from "@/plugins/axios";
@Component({})
export default class ForbiddenDialog extends Vue {
  @Prop()
  private visible: any;
  @Prop()
  private patient: any;
  private reason: any = "";
  private visibleChange() {
    this.$emit("update:visible", this.visible);
  }
  private get ifVisible() {
    return this.visible ? this.visible : false;
  }
  private set ifVisible(val) {
    this.$emit("update:visible", val);
  }
  /**
   * @description 确认
   */
  private confirm() {
    if (!this.reason) {
      this.$message.warning("请选择禁用理由");
      return;
    }
    const params: any = {
      patient_id: this.patient.patient_id,
      project_id: this.patient.project_id,
      group_id: this.patient.group_id,
      action: "禁用",
      禁用理由: this.reason
    };
    axios.post("api/project/patient/do", params).then(({ data }) => {
      resHandle(this, data).then(() => {
        this.$message.success("禁用成功");
        this.reason = "";
        this.$emit("confirm");
        this.ifVisible = false;
      });
    });
  }
}
